export const geography =
[
	{
		code: 'YGS0001',
		name: '华北区'
	},
	{
		code: 'YGS0002',
		name: '东北区'
	},
	{
		code: 'YGS0003',
		name: '西北区'
	},
	{
		code: 'YGS0004',
		name: '华中区'
	},
	{
		code: 'YGS0005',
		name: '西南区'
	},
	{
		code: 'YGS0006',
		name: '华东区'
	},
	{
		code: 'YGS0007',
		name: '华南区'
	}
	// {
	// 	code: 'YGS0008',
	// 	name: '港澳台'
	// }
]
